export default __webpack_public_path__ + "static/media/yljgdz.8b949073.jpg";